import theme_icons from "../../icons.js";

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { InspectorControls, InnerBlocks, ColorPalette } = wp.blockEditor;
const { PanelBody, SelectControl } = wp.components;
const ALLOWED = ["rbt/faqpanel"];

const faq = {
  title: "Greenheart FAQ",
  icon: theme_icons.greenheart,
  category: "greenheart",
  supports: {
    align: ["wide", "full"],
  },
  attributes: {
    containerSize: {
      type: "string",
      default: "full",
    },
    backgroundColor: {
      type: "string",
      default: "",
    },
    textColor: {
      type: "string",
      default: "",
    },
    texture: {
      type: "string",
      default: "none",
    },
  },

  edit({ attributes, setAttributes }) {
    const { containerSize, backgroundColor, textColor, texture } = attributes;
    const textStyle = textColor.length ? { color: textColor } : {};
    return [
      <InspectorControls>
        <PanelBody title={"FAQ Settings"}>
          <p>
            <strong>Texture:</strong>
          </p>
          <SelectControl
            label="Pick Background Texture"
            value={texture}
            options={[
              { label: "None", value: "none" },
              { label: "Sand", value: "sand" },
              { label: "Paint Splash", value: "paint" },
              { label: "Torn Paper", value: "torn-paper" },
            ]}
            onChange={(val) => setAttributes({ texture: val })}
          />
          <p>
            <strong>Accordion Container Size</strong>
          </p>
          <SelectControl
            label="Container Size"
            value={containerSize}
            options={[
              { label: "Full Width", value: "full" },
              { label: "Wide", value: "wide" },
              { label: "Narrow", value: "narrow" },
            ]}
            onChange={(val) => setAttributes({ containerSize: val })}
          />
          <p>
            <strong>Background Color:</strong>
          </p>
          <ColorPalette
            value={backgroundColor}
            onChange={(color) => setAttributes({ backgroundColor: color })}
          />
          <p>
            <strong>Text Color:</strong>
          </p>
          <ColorPalette
            value={textColor}
            onChange={(color) => setAttributes({ textColor: color })}
          />
        </PanelBody>
      </InspectorControls>,
      <div
        className={`faq-wrap ${texture}`}
        style={{
          backgroundColor: backgroundColor || "transparent",
          ...textStyle,
        }}
      >
        {texture === "torn-paper" && <span className="torn-paper-top"></span>}
        {texture === "sand" && <span className="sand-texture"></span>}

        <div style={textStyle} className={"theme-container " + containerSize}>
          <InnerBlocks
            template={["rbt/faqpanel", { title: "New FAQ Title" }]}
            allowedBlocks={ALLOWED}
          />
        </div>
        {texture === "torn-paper" && (
          <span className="torn-paper-bottom"></span>
        )}
      </div>,
    ];
  },
  save({ attributes }) {
    const { containerSize, backgroundColor, textColor, texture } = attributes;
    const textStyle = textColor.length ? { color: textColor } : {};
    return (
      <div
        className={`faq-wrap ${texture}`}
        style={{
          backgroundColor: backgroundColor || "transparent",
          ...textStyle,
        }}
      >
        {texture === "torn-paper" && <span className="torn-paper-top"></span>}
        {texture === "sand" && <span className="pocket-sand"></span>}
        <div style={textStyle} className={"theme-container " + containerSize}>
          <InnerBlocks.Content />
        </div>
        {texture === "torn-paper" && (
          <span className="torn-paper-bottom"></span>
        )}
      </div>
    );
  },
};
registerBlockType("rbt/faq", faq);
export default faq;
